export default "__VITE_ASSET__Cp66$ihM__"